/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Step1_TitleInputs */

const cs_sreality_step1_title = /** @type {(inputs: Sreality_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Firemní RK import`)
};

const en_sreality_step1_title = /** @type {(inputs: Sreality_Step1_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`1. Office RK import`)
};

/**
* | output |
* | --- |
* | "1. Office RK import" |
*
* @param {Sreality_Step1_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_step1_title = /** @type {((inputs?: Sreality_Step1_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Step1_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_step1_title(inputs)
	return cs_sreality_step1_title(inputs)
});